<template>
  <button
    class="text-lg rounded-full"
    :class="[buttonClass, {'bg-[#D9D9D9] text-[#999999]': isDisabled}]"
    @click.prevent="handleClick"
    :disabled="isDisabled || isLoading"
  >
    <span v-if="!isLoading">
      {{ $t(buttonName) }} <span v-if="isDisabled">({{ countdown }})</span>
    </span>
    <span v-else><img class="w-6 h-6" src="../assets/icons/spin.svg"></span>
  </button>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  buttonName: {
    type: String,
    required: true
  },
  buttonClass: {
    type: String,
    default: 'bg-[#00AEEF] text-white px-12 py-3 capitalize font-bold'
  },
  onClick: Function,
  disabled: {
    type: Boolean,
    default: false
  },
  isLoading: {
    type: Boolean,
    default: false
  }
})

const countdown = ref(3)
const isDisabled = ref(props.disabled)

const handleClick = () => {
  if (props.onClick()) props.onClick()
}

watch(() => props.disabled, (val) => {
  if (val) {
    isDisabled.value = true
    countdown.value = 3

    const interval = setInterval(() => {
      countdown.value -= 1

      if (countdown.value <= 0) {
        clearInterval(interval)
        isDisabled.value = false
      }
    }, 1000)
  }
})

</script>